<template>
  <div class="right_main">
    <dv-border-box-7 class="border_material">
      <el-row class="row_title">
        <el-col :span="24">
          <div style="display:flex;">
            <div>
              <dv-decoration-7 class="decoration_7">料架信息</dv-decoration-7>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: center;">
          <h3>料架库存</h3>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <div style="width:150px;margin: auto;">
            <dv-decoration-9 style="width:150px;height:150px;">{{
              materialTitle
            }}</dv-decoration-9>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-row style="text-align: center;">
          <el-col :span="12" :offset="0"><h3>入库比例</h3></el-col>
          <el-col :span="12" :offset="0"><h3>出库比例</h3></el-col>
        </el-row>
      </el-row>
      <el-row>
        <el-row>
          <el-col :span="12" :offset="0"
            ><dv-water-level-pond class="water_level_pond" :config="config2" />
          </el-col>
          <el-col :span="12" :offset="0"
            ><dv-water-level-pond class="water_level_pond" :config="config3"
          /></el-col>
        </el-row>
      </el-row>
      <el-row class="row_title">
        <el-col :span="24">
          <div style="display:flex;">
            <div>
              <dv-decoration-7 class="decoration_7">出库走势</dv-decoration-7>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <dv-conical-column-chart
            :config="config"
            style="width:400px;height:200px;"
          />
        </el-col>
      </el-row>
      <el-row class="row_title">
        <el-col :span="24">
          <div style="display:flex;">
            <div>
              <dv-decoration-7 class="decoration_7">入库走势</dv-decoration-7>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <dv-conical-column-chart
            :config="config1"
            style="width:400px;height:200px;"
          />
        </el-col>
      </el-row>
    </dv-border-box-7>
  </div>
</template>

<script>
import vue from "vue";
import axios from "axios";
import dataV from "@jiaminghi/data-view";
vue.use(dataV);

export default {
  props: ["req_url"],
  name: "DataVChart1",
  data() {
    return {
      config: null,
      config1: null,
      config2: null,
      config3: null,
      dataVData: null,
      materialTitle: "",
      url: this.req_url,
    };
  },
  mounted() {
    axios.get(this.url).then((response) => {
      //console.log(response.data.data);
      this.dataVData = JSON.parse(response.data.data);
      this.materialTitle = this.dataVData.materialTotalData;
      this.config2 = this.dataVData.inputMaterial;
      this.config3 = this.dataVData.outputMaterial;
    });
  },
  methods: {},
};
</script>

<style scoped>
.water_level_pond {
  width: 150px;
  height: 200px;
  margin: auto;
}

.decoration_7 {
  width: 150px;
  height: 30px;
}

.row_title {
  padding: 10px 0px;
}

.border_space {
  margin-top: 15px;
}

.border_material {
  padding-bottom: 20px;
}

.right_main {
  width: 100%;
  color: white;
  min-width: 300px;
}
</style>
